<template>
    <div>
        <div
            id="content"
            class="content animated slideInRight delay-1s"
        >
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">Exportar Veículos</div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="card-body">
                                    <form
                                        :action="$store.state.url + 'export/vehicles/'"
                                        id="export"
                                    >

                                        <input
                                            type="hidden"
                                            v-model="this.$store.state.user.id"
                                            class="form-control"
                                            name="uid"
                                            id="uid"
                                        />

                                        <div class="block text-right">
                                            <button
                                                class="btn btn-add"
                                                type="submit"
                                            >
                                                Exportar em Excel
                                                <i class="fas fa-file-export ml-2"></i>
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    methods: {},
    mounted: function () {
    },
    components: {},
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Exportation/Vehicles.vue